import type { onChangeDOM } from '@sdk/types/DOM';

import type { RestBreakThresholdField } from '../types/OrgSettingsFields';
import {
  setRestBreakThresholdHours,
  validateRestBreakThreshold,
} from '../../../../settings/components/schedule/helpers/utils';

export const useClopening = (restBreakThresholdField: RestBreakThresholdField) => {
  const onChangeHandler: onChangeDOM = (event) => {
    const { value } = event.currentTarget;

    if (validateRestBreakThreshold(value)) {
      restBreakThresholdField.onChange(setRestBreakThresholdHours(value));
      return;
    }

    restBreakThresholdField.onChange(value);
  };

  return { onChangeHandler };
};
